import XInput from "./common/XInput"
import XLink from "./common/XLink"
import { cardTitleClasses } from "./common/formClasses"

const ProfileForm = ({ formik, resetPasswordPath = "" }) => {

    return (
        <>

            <div className="col-md-6">
                <div className={`title ${cardTitleClasses}`}>
                    <h2>Personal Information</h2>
                </div>
                <div className="form-group">
                    <XInput
                        name="firstName"
                        label="First Name"
                        placeholder="Enter here"
                        {...formik.getFieldProps("firstName")}
                        error={formik.touched.firstName && formik.errors.firstName}
                    />
                </div>
                <div className="form-group">
                    <XInput
                        name="lastName"
                        label="Last Name"
                        placeholder="Enter here"
                        {...formik.getFieldProps("lastName")}
                        error={formik.touched.lastName && formik.errors.lastName}
                    />
                </div>
                <div className="form-group">
                    <XInput
                        disabled
                        name="email"
                        type="email"
                        label="Email Address"
                        placeholder="Enter here"
                        {...formik.getFieldProps("email")}
                        error={formik.touched.email && formik.errors.email}
                    />
                </div>
                <XLink to={resetPasswordPath}>Reset Password?</XLink>
            </div>
        </>
    )
}

export default ProfileForm
